/**
 * @file Central React Query key factories for auction/bidder/scan caches.
 */

export const queryKeys = {
  auctionGroups: () => ['auctionGroups'],
  auctionGroup: (id) => ['auctionGroup', id],
  mergePreflight: (id) => ['mergePreflight', id],
  bidders: (filters) => ['bidders', filters],
  bidder: (bidderId, auctionGroupId, extra) => ['bidder', bidderId, auctionGroupId, extra].filter((v) => v !== undefined),
  bidderLots: (bidderId, auctionGroupId) => ['bidder-lots', bidderId, auctionGroupId],
  bidderLotsScan: (bidderId, auctionGroupId) => ['bidder-lots-scan', bidderId, auctionGroupId],
  noBidsLots: (auctionGroupId) => ['no-bids-lots', auctionGroupId],
  noBidsLotsScan: (auctionGroupId) => ['no-bids-lots-scan', auctionGroupId],
  manifestStatistics: (auctionGroupId) => ['manifestStatistics', auctionGroupId],
  lotsWithoutManifest: (auctionGroupId) => ['lotsWithoutManifest', auctionGroupId],
};
